/* ============================================================
   SIMPATICO CUSTOMS — low-friction CTA behavior
   Companion to simpatico-custom.js. Everything here is
   progressive enhancement: with JS off, the sms: links still
   open the messages app and the action bar still shows.
   ============================================================ */
(function () {
  'use strict';

  /* Google Ads conversion label for the sms: lead action. See the note in
     simpatico-custom.js — the main-window Google tag has no GA4 destination,
     so this has to go straight to the Ads tag. */
  var SC_ADS_LABELS = {
    consult_text_click: 'AW-17721956038/P_0PCO2wpN0cEMatvoJC'
  };

  function scTrack(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
        if (SC_ADS_LABELS[name]) {
          window.gtag('event', 'conversion', { send_to: SC_ADS_LABELS[name] });
        }
      }
    } catch (e) {
      /* swallow: a tracking failure must not affect the lead flow */
    }
  }

  /* ---------- (1) text-us taps ----------
     tel: taps are already covered by consult_call_click in
     simpatico-custom.js. sms: is a separate, lower-friction lead
     action and gets its own event so the two can be compared in
     GA4 and imported into Google Ads independently.
     Capture phase, so it still records when the browser hands the
     sms: link off to the messages app. */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest
      ? e.target.closest('a[href^="sms:"]')
      : null;
    if (!link) return;
    scTrack('consult_text_click', {
      lead_source: 'simpatico_customs_sms',
      placement: link.getAttribute('data-sc-lead') || 'other'
    });
  }, true);

  /* ---------- (2) sticky mobile action bar ----------
     Hide the bar once the consult section is on screen, so it
     never sits on top of the form it is pointing at.

     Deliberately scroll-driven rather than IntersectionObserver:
     the behavior is then directly assertable from the rendered
     page (IO callbacks are suspended in a non-visible document,
     which makes the same logic impossible to verify headlessly).
     Listener is passive and time-throttled, so it costs nothing
     on scroll. */
  var bar = document.getElementById('sc-actionbar');
  var consult = document.getElementById('consult');

  function syncBar() {
    if (!bar || !consult) return;
    var r = consult.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    /* "on screen" = the section has entered the lower third and
       has not yet scrolled past the top */
    var onScreen = r.top < vh * 0.65 && r.bottom > 0;
    bar.setAttribute('data-sc-hidden', onScreen ? 'true' : 'false');
  }

  if (bar && consult) {
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.setTimeout(function () {
        queued = false;
        syncBar();
      }, 120);
    }, { passive: true });
    window.addEventListener('resize', syncBar, { passive: true });
    syncBar();
  }

  /* Also hide it while the on-screen keyboard is likely open, so it
     doesn't cover the field being typed into on short viewports. */
  if (bar) {
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('input, textarea, select')) {
        bar.setAttribute('data-sc-hidden', 'true');
      }
    });
  }
})();
